import React, { useState } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import ButtonUI from '../../../../components/UI/ButtonUI';
import { Row, Modal, Button } from 'react-materialize';
import { isNullOrEmpty, showMessageToastCustom, translate } from '../../../../utils/util';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';

const ModalUpload = (props) => {
    const typeCim = props.typeModal === "CIM";
    const typePartNumber = props.typeModal === "PARTNUMBER";

    const [selectedFile, setSelectedFile] = useState();

    const onCancel = (event) => {
        if (props.onCancel) {
            props.onCancel(event);
        }
        close();
    };

    const close = () => {
        if (props.onClose) {
            props.onClose();
        }
    };

    const sendCim = async () => {
        try {
            if (!selectedFile) {
                showMessageToastCustom(translate('warning', 'general'), translate('selectFileToContinue', 'general'), 3000, 'mdi mdi-alert-circle-outline red-text');
                return
            }

            var data = new Uint8Array(await selectedFile.arrayBuffer());
            var workbook = XLSX.read(data);
            var sheets = XLSX.utils.sheet_to_json(workbook.Sheets[workbook.SheetNames[0]], {
                raw: true
            })

            var cims = sheets.map((item) => item.CIMs).filter(f => !isNullOrEmpty(f));

            if (cims.length > 0) {
                props.callback(sheets.map((item) => item.CIMs));
                close();
            }

            return showMessageToastCustom(translate('warning', 'general'), "Nenhum CIM encontrado!", 3000, 'mdi mdi-alert-circle-outline red-text');
        } catch (error) {
            console.error(error);
            showMessageToastCustom(translate('warning', 'general'), error, 3000, 'mdi mdi-alert-circle-outline red-text');
        }
    };

    const sendPartNumber = async () => {
        try {
            if (!selectedFile) {
                showMessageToastCustom(translate('warning', 'general'), translate('selectFileToContinue', 'general'), 3000, 'mdi mdi-alert-circle-outline red-text');
                return
            }

            if (typePartNumber) {
                var data = new Uint8Array(await selectedFile.arrayBuffer());
                var workbook = XLSX.read(data);
                var sheets = XLSX.utils.sheet_to_json(workbook.Sheets[workbook.SheetNames[0]], {
                    raw: true
                })

                var partNumbers = sheets.map((item) => item)
                    .filter(f => !isNullOrEmpty(f.DESENHO) && !isNullOrEmpty(f.QTDETOTAL));

                if (partNumbers.length > 0) {
                    props.callback(partNumbers);
                    close();
                } else {
                    return showMessageToastCustom(translate('warning', 'general'), "Nenhum Desenho encontrado!", 3000, 'mdi mdi-alert-circle-outline red-text');
                }
            }
        } catch (error) {
            showMessageToastCustom(translate('warning', 'general'), error, 3000, 'mdi mdi-alert-circle-outline red-text');
        }
    };

    const clearFileInput = () => {
        document.getElementById("fileInput").value = "";
        setSelectedFile();
    }

    const exportExcel = () => {
        const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.shee;charset=UTF-8';
        let ws;
        if (typeCim) {
            ws = XLSX.utils.json_to_sheet([{
                'CIMs': ""
            }]);
        } else if (typePartNumber) {
            ws = XLSX.utils.json_to_sheet([{
                'DESENHO': "",
                'QTDETOTAL': "",
                // 'TIPOMDR': "",
                // 'NRMDR': "",
                // 'QTDEPORMDR': ""
            }]);
        }

        const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const data = new Blob([excelBuffer], { type: fileType });
        FileSaver.saveAs(data, `Template${typeCim ? "Cim" : "MaterialMake"}.xlsx`);
    }

    return (
        <Modal
            open={props.open}
            options={{ dismissible: false }}
            id={props.id || 'ModalUpload'}
            actions={
                <Row className="center" style={{ height: "60%" }}>
                    <Button
                        onClick={onCancel}
                        className="col s6 btn waves-effect waves-light btn-flat"
                        modal="close"
                        disabled={props.disabledCancel}>
                        {props.btnCancel ? props.btnCancel : translate('cancel', 'general')}
                    </Button>
                    <ButtonUI
                        onClick={typeCim ? sendCim : sendPartNumber}
                        text={props.btnConfirm ? props.btnConfirm : translate('add', 'general')} />
                </Row>
            }>
            <div>
                {
                    props.open &&
                    <>
                        <Row className="center">
                            <div className="sixth-text-color center">
                                <span className="title col s12">Upload {typeCim ? "CIM `S" : "Material Make e PAB"}</span>
                            </div>
                            <div className="title" style={{ float: 'right', margin: '0px' }}>
                                <i className="mdi mdi-24px mdi-arrow-down-circle"
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => exportExcel()}
                                />
                            </div>
                        </Row>
                        <div id="formInput" className='row'>
                            <div className="input-field no-padding col s12">
                                <input
                                    id="fileInput"
                                    required
                                    type="file"
                                    onClick={clearFileInput}
                                    onChange={(event) => setSelectedFile(event.target.files[0])}
                                    accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                                />
                            </div>
                        </div>
                    </>
                }
            </div>
        </Modal >
    );
};

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
    };
};

const mapDispatchToProps = () => {
    return {
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ModalUpload));